"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Heading, HStack, VStack } from "@navikt/ds-react";
import { revalidateLogic } from "@tanstack/react-form";
import { useBehovAction } from "@/app/(behov)/[behovId]/hooks/useBehovAction";
import { useBehovContextState } from "@/app/(behov)/[behovId]/state/contextState";
import { lederSchema } from "@/schemas/nærmestelederFormSchema";
import ErrorAlert from "@/shared/components/ErrorAlert";
import { useAppForm } from "@/shared/components/form/hooks/form";
import { LederGroup } from "@/shared/components/form/LederGroup";
import { UiSelector } from "@/utils/uiSelectors";
export default function BehovForm() {
  const $ = _c(28);
  const {
    submittedData,
    handleSuccess,
    behovId
  } = useBehovContextState();
  const {
    error,
    startOppdaterNarmesteLeder
  } = useBehovAction();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = revalidateLogic();
    t1 = {
      onDynamic: lederSchema
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== behovId || $[3] !== handleSuccess || $[4] !== startOppdaterNarmesteLeder) {
    t2 = t3 => {
      const {
        value
      } = t3;
      return startOppdaterNarmesteLeder(behovId, value.leder, {
        onSuccess() {
          handleSuccess(value);
        }
      });
    };
    $[2] = behovId;
    $[3] = handleSuccess;
    $[4] = startOppdaterNarmesteLeder;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== submittedData || $[7] !== t2) {
    t3 = {
      defaultValues: submittedData,
      validationLogic: t0,
      validators: t1,
      onSubmit: t2
    };
    $[6] = submittedData;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const form = useAppForm(t3);
  let t4;
  if ($[9] !== form) {
    t4 = async e => {
      e.preventDefault();
      e.stopPropagation();
      await form.handleSubmit();
    };
    $[9] = form;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Heading className="mt-2" level="2" size="medium">Nærmeste leder</Heading>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== form) {
    t6 = <LederGroup form={form} fields="leder" />;
    $[12] = form;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== error) {
    t7 = error && <ErrorAlert detail={error} />;
    $[14] = error;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== form.BoundSubmitButton) {
    t8 = <HStack className="mt-0"><form.BoundSubmitButton label="Send inn" uiSelector={UiSelector.SendInn} /></HStack>;
    $[16] = form.BoundSubmitButton;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <VStack gap="space-32"><Box padding="space-16" background="accent-soft" borderRadius="8"><VStack gap="space-24" className="w-full max-w-md">{t5}{t6}{t7}{t8}</VStack></Box></VStack>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== form.AppForm || $[23] !== t9) {
    t10 = <form.AppForm>{t9}</form.AppForm>;
    $[22] = form.AppForm;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4) {
    t11 = <form data-testid={UiSelector.BehovForm} onSubmit={t4}>{t10}</form>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}